import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 1,
  class: ""
}

import {onMounted, Ref, ref} from "vue";
import {store} from "@/store";
import {client, trackEvent} from '@/shared';
import {Fan, Unfan} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'Fanning',
  props: {
    id: String,
    numberOfFans: Number,
    type: String
},
  setup(__props) {

// @ts-ignore
const props = __props
const id: Ref<String> = ref(props.id);
let numberOfFans: Ref<Number> = ref(props.numberOfFans ?? 0);
let isFanned: Ref<Boolean> = ref(false);
let type = props.type ?? "card";

onMounted((): void => {
    if (store.saUserSession.fannedItems.includes(id.value.toLowerCase())) {
        isFanned.value = true;
    }
});

const fan = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.post(new Fan({id: id.value}))
        .then(() => {
            isFanned.value = true;
            numberOfFans.value++;
            
            trackEvent( 'fan', {
                content_id: id.value,
                content_type: id.value.split('/', 1)
            });
        })
};
const unFan = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.delete(new Unfan({id: id.value}))
        .then(() => {
            isFanned.value = false;
            numberOfFans.value--;
        })
};

return (_ctx: any,_cache: any) => {
  return (_unref(type) === 'page')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isFanned))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              "aria-label": "Unfan",
              class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
              href: "#",
              onClick: _withModifiers(unFan, ["prevent"])
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-heart -ml-0.5 mr-2 h-4 w-4" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(numberOfFans)), 1)
            ]))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              "aria-label": "Fan",
              class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
              href: "#",
              onClick: _withModifiers(fan, ["prevent"])
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "far fa-heart -ml-0.5 mr-2 h-4 w-4" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(numberOfFans)), 1)
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_unref(isFanned))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              "aria-label": "Unfan",
              class: "px-3 py-2 rounded-xl text-clay-800",
              href: "#",
              onClick: _withModifiers(unFan, ["prevent"])
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "mr-2 fas fa-heart hover:text-electric-700 hover:animate-ping" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(numberOfFans)), 1)
            ]))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              "aria-label": "Fan",
              class: "px-3 py-2 rounded-xl text-clay-800",
              href: "#",
              onClick: _withModifiers(fan, ["prevent"])
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "mr-2 far fa-heart hover:text-electric-700 hover:animate-ping" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(numberOfFans)), 1)
            ]))
      ]))
}
}

})